import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DateRangePickerComponent } from './date-range-picker.component';

@NgModule({
  declarations: [DateRangePickerComponent],
  imports: [
    FormsModule,
    CommonModule,
    NgxDaterangepickerMd.forRoot(),
  ],
  exports: [DateRangePickerComponent],
})
export class DateRangePickerModule { }
